// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
    display: flex;
    flex-direction: row;
    width: 100%;
    background: rgba(255, 244, 217, 1);
    border-radius: 24px 24px 0 0;
    padding: 20px 22px;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999;
}

.navigationItem {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
    justify-content: center;
    width: 47px;
}

.navigationItemIcon {
    width: 30px;
    height: 30px;
}

.navigationItemText {
    font-size: 12px;
    font-weight: 700;
    line-height: 16.8px;
    text-align: left;
    color: #4B2D10;
    text-decoration: none;
}

.navigationItemTextGray {
    font-size: 12px;
    font-weight: 700;
    line-height: 16.8px;
    text-align: left;
    color: #B8B8B8;
    text-decoration: none;
}

.linkNoUnderlineNavigation {
    text-decoration: none;
}

@media (min-width: 480px) {
    .navigationItemText, .navigationItemTextGray {
        font-size: 14px;
    }
}

@media (min-width: 768px) {
    .main {
        padding: 20px 35px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Navigation/Navigation.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kCAAkC;IAClC,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,OAAO;IACP,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".main {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    background: rgba(255, 244, 217, 1);\n    border-radius: 24px 24px 0 0;\n    padding: 20px 22px;\n    align-items: center;\n    justify-content: space-between;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    z-index: 999;\n}\n\n.navigationItem {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    align-items: center;\n    justify-content: center;\n    width: 47px;\n}\n\n.navigationItemIcon {\n    width: 30px;\n    height: 30px;\n}\n\n.navigationItemText {\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 16.8px;\n    text-align: left;\n    color: #4B2D10;\n    text-decoration: none;\n}\n\n.navigationItemTextGray {\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 16.8px;\n    text-align: left;\n    color: #B8B8B8;\n    text-decoration: none;\n}\n\n.linkNoUnderlineNavigation {\n    text-decoration: none;\n}\n\n@media (min-width: 480px) {\n    .navigationItemText, .navigationItemTextGray {\n        font-size: 14px;\n    }\n}\n\n@media (min-width: 768px) {\n    .main {\n        padding: 20px 35px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
